import React, { useState, useRef, useEffect } from 'react';
import { Input } from '@/components/ui/inputs/input';
import InputRadio from '@/components/ui/inputs/input-radio';
import { useForm, Controller } from 'react-hook-form';
import { addAdminService, updateAdminService, getByIdAdminService } from '@/services/AdminServices';
import validationErrors from '@/lib/validationErrors';
import SidebarDrawer from '@/components/common/SidebarDrawer';
import { useSelector, useDispatch } from 'react-redux';
import ToastMe from '@/components/ui/ToastMe';

const AddEditDrawer = ({ titleText, activeDrawer, setActiveDrawer, getTableData, editDataId = '' }) => {
    const {
        register,
        setValue,
        getValues,
        formState: { errors },
        handleSubmit,
        control,
        reset,
    } = useForm();
    const dispatch = useDispatch();

    const [itemStatus, setItemStatus] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [isFormSumbmit, setIsFormSumbmit] = useState(false);

    useEffect(() => {
        if (activeDrawer && activeDrawer != '') {
            formReset();
            if (editDataId && editDataId != '') {
                getDataById(editDataId);
            }
        }
    }, [activeDrawer]);

    const formReset = async () => {
        try {
            var formData = getValues();
            for (const key in formData) {
                await setValue(key, '');
            }
            await reset();
            await setValue('status', '1');
            await setItemStatus(1);
        } catch (error) {
            console.error('Error in onReset:', error);
        }
    };

    const handleDrawerClose = () => {
        formReset();
        setActiveDrawer(false);
        document.body.style.overflowY = 'auto';
        getTableData();
    };

    const handleChangeStatus = (event) => {
        setValue('status', event.target.value);
        setItemStatus(event.target.value);
    };

    const getDataById = (editId) => {
        setIsLoading(true);
        dispatch(getByIdAdminService(editId))
            .then((res) => {
                var formData = res?.data?.data;
                for (const key in formData) {
                    if (formData.hasOwnProperty(key) && formData[key] != '') {
                        setValue(key, formData[key]);
                    } else {
                        setValue(key, '');
                    }
                }
                if (formData) {
                    setValue('status', formData.status);
                    setItemStatus(formData.status);
                }
                setValue('password', '');
                setValue('confirm_password', '');
                setIsLoading(false);
            })
            .catch(({ message, errorData, statusCode }) => {
                validationErrors(errorData, message);
                setIsLoading(false);
            });
    };

    const onSubmit = (data) => {
        if (data.confirm_password != data.password) {
            ToastMe('Password and confirm password not same', 'error');
            return true;
        }
        setIsFormSumbmit(true);
        data.isSuperAdmin = 1;
        var addEditService = '';
        if (editDataId && editDataId != '') {
            addEditService = updateAdminService(editDataId, data);
        } else {
            addEditService = addAdminService(data);
        }
        dispatch(addEditService)
            .then((res) => {
                formReset();
                setIsFormSumbmit(false);
                handleDrawerClose();
            })
            .catch(({ message, errorData, statusCode }) => {
                validationErrors(errorData, message);
                setIsFormSumbmit(false);
            });
    };

    return (
        <SidebarDrawer icon="lab lab-add-circle-line" titleText={titleText} activeDrawer={activeDrawer} handleDrawerClose={handleDrawerClose}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <Controller
                        control={control}
                        rules={{ required: true, minLength: 2, maxLength: 20 }}
                        name="name"
                        render={({ field }) => (
                            <Input
                                {...field}
                                labelStyleClassName="db-field-title required"
                                size="sm"
                                labelText={'Name'}
                                type="text"
                                errorData={{ minLength: '2', maxLength: '20' }}
                                errorType={errors?.name?.type}
                            />
                        )}
                    />

                    <Controller
                        control={control}
                        rules={{ required: true, pattern: /^[^@ ]+@[^@ ]+\.[^@ .]{2,}$/ }}
                        name="email"
                        render={({ field }) => (
                            <Input
                                {...field}
                                labelStyleClassName="db-field-title required"
                                size="sm"
                                labelText={'Email'}
                                type="text"
                                errorData={{ minLength: '6', maxLength: '20' }}
                                errorType={errors?.email?.type}
                            />
                        )}
                    />

                    <Controller
                        control={control}
                        rules={{ required: true, minLength: 10, maxLength: 12 }}
                        name="phone_no"
                        render={({ field }) => (
                            <Input
                                {...field}
                                labelStyleClassName="db-field-title required"
                                size="sm"
                                labelText={'Phone'}
                                type="text"
                                id="phone"
                                errorData={{ minLength: '10', maxLength: '12' }}
                                errorType={errors?.phone_no?.type}
                            />
                        )}
                    />

                    <div className="form-input-item">
                        <label className="db-field-title required" htmlFor="active">
                            {'Status'}
                        </label>
                        <div className="db-field-radio-group">
                            <InputRadio
                                id="active"
                                name="status"
                                labelText={'Active'}
                                value="1"
                                onChange={() => handleChangeStatus({ target: { name: 'status', value: 1 } })}
                                checked={itemStatus == '1' ? true : false}
                            />
                            <InputRadio
                                id="inactive"
                                name="status"
                                labelText={'Inactive'}
                                value="2"
                                onChange={() => handleChangeStatus({ target: { name: 'status', value: 2 } })}
                                checked={itemStatus == '2' ? true : false}
                            />
                        </div>
                    </div>

                    <Controller
                        control={control}
                        rules={editDataId && editDataId != '' ? { minLength: 6, maxLength: 20 } : { required: true, minLength: 6, maxLength: 20 }}
                        name="password"
                        render={({ field }) => (
                            <Input
                                {...field}
                                type="text"
                                labelStyleClassName={editDataId && editDataId != '' ? '' : 'db-field-title required'}
                                labelText={'New Password'}
                                autoComplete="off"
                                errorData={{ minLength: '6', maxLength: '20' }}
                                errorType={errors?.password?.type}
                            />
                        )}
                    />

                    <Controller
                        control={control}
                        rules={editDataId && editDataId != '' ? { minLength: 6, maxLength: 20 } : { required: true, minLength: 6, maxLength: 20 }}
                        name="confirm_password"
                        render={({ field }) => (
                            <Input
                                {...field}
                                labelStyleClassName={editDataId && editDataId != '' ? '' : 'db-field-title required'}
                                type="text"
                                labelText={'Confirm Password'}
                                autoComplete="off"
                                errorData={{ minLength: '6', maxLength: '20' }}
                                errorType={errors?.confirm_password?.type}
                            />
                        )}
                    />
                </div>
                <div className="form-col-12">
                    <div className="flex flex-wrap gap-3 mt-4">
                        <button type="submit" className="db-btn py-2 text-white bg-primary" disabled={isFormSumbmit || isLoading ? true : false}>
                            <i className="lab lab-save"></i>
                            <span>save</span>
                            {isFormSumbmit ? (
                                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                    <path
                                        className="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                            ) : (
                                <></>
                            )}
                        </button>
                        <button type="button" className="modal-btn-outline modal-close" onClick={handleDrawerClose}>
                            <i className="lab lab-close"></i>
                            <span>close</span>
                        </button>
                    </div>
                </div>
            </form>
        </SidebarDrawer>
    );
};

export default AddEditDrawer;
